module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "a-upload",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "file"
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-plus-square fa-lg"
  }), _vm._v(" "), _c('translate', [_vm._v("Upload")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490a7a6c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/operations/model/vue-file-base64.vue
// module id = 559
// module chunks = 4 5 6